import React from 'react';
import { useTranslations } from '@mentimeter/i18n';
import { Button } from 'src/ui/actions';
import CloneButton from 'src/components/CloneButton';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';

interface Props {
  description: string;
  previewUrl: string;
  presentationId: string;
  title: string;
}

export const Overlay = React.memo(
  ({ description, previewUrl, presentationId, title }: Props) => {
    const t = useTranslations('common');

    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        position="absolute"
        top={0}
        bottom={0}
        right={0}
        left={0}
        px="space4"
        py={20}
        extend={({ theme }) => ({
          opacity: 0,
          backgroundColor: theme.colors.bg,
          transition: `opacity ${theme.durations[2]}s`,
          ':hover, :focus-within': {
            opacity: 1,
          },
        })}
      >
        <Box>
          <Text color="text" fontSize="100">
            {description}
          </Text>
        </Box>
        <Box display="flex" flexDirection="row">
          <CloneButton seriesId={presentationId} name={title} mr="space2" />
          <Button
            data-testid="preview-link"
            href={previewUrl}
            variant="secondary"
          >
            {t('templates.preview')}
          </Button>
        </Box>
      </Box>
    );
  },
);
